import Rollbar from "rollbar";

/**
 * Singleton Rollbar instance for logging React Query errors
 * Initialized lazily to avoid circular dependencies with providers
 */
let rollbarInstance: Rollbar | null = null;

/**
 * Initialize the error logger with a Rollbar instance
 * Called by DataLayerProvider after Rollbar is available
 */
export const initErrorLogger = (rollbar: Rollbar): void => {
  rollbarInstance = rollbar;
};

/**
 * Log React Query errors with context
 * Falls back to console.error if Rollbar not initialized
 */
export const logReactQueryError = (
  error: unknown,
  context: {
    type: "query" | "mutation";
    key?: unknown;
  }
): void => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : undefined;

  const logContext = {
    type: context.type,
    queryKey: context.key,
    error: errorMessage,
    stack: errorStack,
    timestamp: new Date().toISOString(),
    url: typeof window !== "undefined" ? window.location.href : undefined,
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : undefined,
  };

  // Always log to console for debugging
  if (process.env.NODE_ENV !== "production") {
    console.error("[React Query Error]", logContext);
  }

  // Log to Rollbar in production if available
  if (rollbarInstance && process.env.NODE_ENV === "production") {
    const title = `[React Query ${context.type}] ${errorMessage}`;
    rollbarInstance.error(title, error instanceof Error ? error : new Error(errorMessage), {
      custom: logContext,
    });
  }
};